// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tipsMask":"tipsMask-2xn8PiEY","textCenter":"textCenter-yb9iPDfq","tipsText":"tipsText-bW_ulwF-","openClient":"openClient-2F-HkFMq"};